var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wl-container" }, [
    _c(
      "div",
      { staticClass: "wl-content-container" },
      [
        _c("div", { staticClass: "wl-search-bar" }, [
          _c(
            "div",
            { staticClass: "wl-left" },
            [
              _c(
                "el-input",
                {
                  staticClass: "input-with-select",
                  attrs: {
                    placeholder:
                      _vm.$t("TABLE_HEADER_roleName") +
                      "," +
                      _vm.$t("FORM_LABEL_description"),
                    clearable: "",
                    maxlength: "100",
                  },
                  on: { clear: _vm.getRoleList },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.getRoleList.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.queryParam,
                    callback: function ($$v) {
                      _vm.queryParam = $$v
                    },
                    expression: "queryParam",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    staticStyle: { cursor: "pointer" },
                    attrs: { slot: "suffix" },
                    on: { click: _vm.getRoleList },
                    slot: "suffix",
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "wl-right" },
            [
              _c(
                "el-button",
                {
                  staticClass: "wl-green svg-btn",
                  attrs: { disabled: _vm.patch.show },
                  on: { click: _vm.onPatchDeleteClick },
                },
                [
                  _c("img", {
                    staticClass: "btn-icon",
                    attrs: {
                      src: require("@/assets/img/icon-batchdeletion.svg"),
                      width: "100%",
                    },
                  }),
                  _vm._v(_vm._s(_vm.$t("patch_delete")) + "\n        "),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: { icon: "el-icon-plus" },
                  on: { click: _vm.openRole },
                },
                [_vm._v(_vm._s(_vm.$t("PAGE_CLIENTROLES_ADD")) + "\n        ")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            class: [
              "table-container-wrapper",
              _vm.patch.show ? "show-table-bottom-operate" : "",
            ],
          },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "mainTable",
                attrs: {
                  height: "100%",
                  data: _vm.data,
                  border: "",
                  stripe: "",
                },
                on: { "selection-change": _vm.onTableSelectChange },
              },
              [
                _vm.patch.show
                  ? _c("el-table-column", {
                      attrs: { type: "selection", width: "55" },
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: { type: "index", align: "center", width: "70" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "roleName",
                    "min-width": "150",
                    label: _vm.$t("TABLE_HEADER_roleName"),
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "roleDesc",
                    align: "center",
                    label: _vm.$t("FORM_LABEL_description"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "updateDateString",
                    align: "center",
                    label: _vm.$t("TABLE_HEADER_modifyDate"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("formatDate")(scope.row.updateDateString)
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "action",
                    width: "170",
                    align: "center",
                    label: _vm.$t("TABLE_HEADER_Action"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("i", {
                            staticClass: "el-icon-edit-outline wl-icon-edit",
                            on: {
                              click: function ($event) {
                                return _vm.editRole(scope.row)
                              },
                            },
                          }),
                          _c("i", {
                            staticClass: "el-icon-delete wl-icon-delete",
                            staticStyle: { "margin-left": "10px" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteRole(scope.row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.patch.show
          ? _c(
              "div",
              { staticClass: "patch-bottom-btn" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "cancel-btn",
                    on: { click: _vm.onPatchCancelClick },
                  },
                  [_vm._v(_vm._s(_vm.$t("btn_cancel")) + "\n        ")]
                ),
                _vm.patch.show && _vm.patch.mode == "delete"
                  ? _c(
                      "el-button",
                      {
                        staticClass: "wl-green",
                        attrs: { disabled: _vm.patch.selectedRows.length <= 0 },
                        on: { click: _vm.commitPatchDelete },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("patch_delete")) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _c("el-pagination", {
          staticClass: "wl-pagination",
          attrs: {
            "current-page": _vm.pagination.pageNum,
            "page-size": _vm.pagination.pageSize,
            "page-sizes": [10, 50, 100],
            layout: "prev, pager, next, sizes, total",
            total: _vm.pagination.total,
          },
          on: {
            "current-change": _vm.onCurrentPageChange,
            "size-change": _vm.onSizeChange,
          },
        }),
        _vm.addVisible
          ? _c("clientRoles-add", {
              attrs: {
                saveLoading: _vm.btnLoading,
                initData: _vm.initData,
                onCancel: _vm.toggleAddVisible,
                onAdd: _vm.saveClientRoles,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }